// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"TrackedAs_cancelButton__2WwRz"};